import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";  
import "./DialerLogs.css";  

function DialerLogs() {
    const { formId } = useParams();  
    const [logs, setLogs] = useState([]);
    const [forms, setForms] = useState([]);  
    const [campaignFormName, setCampaignFormName] = useState(null);  
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchLogs();
        fetchForms();  
    }, [formId]);

    const fetchLogs = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`https://leadbankapi.gensparc.com/api/dialer-logs/${formId}`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch logs");
            }

            const data = await response.json();
            setLogs(data);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchForms = async () => {
        try {
            const token = localStorage.getItem("token");

            const response = await fetch("https://leadbankapi.gensparc.com/api/forms", {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            if (!response.ok) throw new Error("Failed to fetch forms");
            const data = await response.json();
            setForms(data);

            // If formId is not found in forms, check in campaigns
            const found = data.find(f => f.id === formId);
            if (!found) {
                fetchCampaignFormName(token);
            }
        } catch (error) {
            console.error("Error fetching forms:", error);
        }
    };

    const fetchCampaignFormName = async (token) => {
        try {
            const response = await fetch("https://leadbankapi.gensparc.com/api/facebook/campaign", {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });

            if (!response.ok) throw new Error("Failed to fetch campaign data");

            const data = await response.json();
            const campaign = data.find(c => c.formId === formId);

            if (campaign) {
                setCampaignFormName(campaign.formName);
            }
        } catch (error) {
            console.error("Error fetching campaign form name:", error);
        }
    };

    const getFormName = (formId) => {
        const form = forms.find((f) => f.id === formId);
        if (form) return form.name;
        return campaignFormName || "Unknown Form";
    };

    return (
        <div className="dialer-logs-container">
            <h2 className="dialer-logs-title">Leadbank To Dialer Report</h2>

            <h2 className="dialer-logs-title">Form Name: {getFormName(formId)}</h2>

            {loading ? (
                <p className="loading">Loading logs...</p>
            ) : error ? (
                <p className="error-message">{error}</p>
            ) : logs.length === 0 ? (
                <p className="no-logs">No logs found for this form.</p>
            ) : (
                <div className="dialer-logs-wrapper">
                    <table className="dialer-logs-table">
                        <thead>
                            <tr>
                                {/* <th>ID</th> */}
                                {/* <th>Form Name</th> */}
                                <th>Form Data</th>
                                <th>Status At Dialer</th>
                                <th>Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((log) => (
                                <tr key={log.id}>
                                    {/* <td>{log.id}</td>
                                    <td>{getFormName(log.form_id)}</td>   */}
                                    <td>
                                        <pre className="mapped-data">
                                            {log.mapped_data 
                                                ? Object.entries(JSON.parse(log.mapped_data))
                                                      .map(([key, value]) => `${key}: ${value}`)
                                                      .join("\n") 
                                                : "No Data"}
                                        </pre>
                                    </td>
                                    <td>{log.response_message}
                                        <div className={`response-code ${log.response_code === 1 ? 'success' : 'error'}`}>
                                            ({log.response_code})
                                        </div>
                                    </td>
                                    <td>{new Date(log.created_at).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default DialerLogs;
